import React, { useEffect, useState } from 'react'
import {
  Checkbox,
  InputLabel,
  Box,
  Button,
  unstable_useId,
} from "@mui/material";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import { useDispatch, useSelector } from 'react-redux';
import _, { uniqueId } from 'lodash';
import { commonFileUpload } from 'src/thunks/dashboard';
import { toast } from 'react-toastify';
import { GetError } from 'src/constant';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import IconError from "src/assets/images/icon_error.svg";

const UploadImage = ({ Item, setItem, toggle, isdisable, detailsView, selectedItemImagesArray }) => {
  const dispatch = useDispatch()
  const [photoLoader, setPhotoLoader] = useState(false);
  const [newImagesArray, setNewImagesArray] = useState([]);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const lookupValues = useSelector((state) => state.lookup.data);


  useEffect(() => {
    setNewImagesArray([...Item?.shipmentItemEvidences || []])
  }, [Item])

  const IsDamageChangeHandler = (ichecked, id) => {
    let filesArrayMapedData = _.map(newImagesArray, (d) => {
      let temp = { ...d };
      if (d.uniqueFileId === id) {
        temp.isDamaged = ichecked;
      }
      return temp;
    });
    setNewImagesArray([...filesArrayMapedData]);
  };

  const openFullScreen = (image) => {
    setIsFullScreen(true);
    setSelectedImage(image);
  };

  const closeFullScreen = () => {
    setIsFullScreen(false);
    setSelectedImage(null);
  };

  const photoUpload = async (e) => {
    setPhotoLoader(true);
    const files = e.target.files;
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    try {
      let res = await dispatch(commonFileUpload(formData)).unwrap();
      let PhotoType = lookupValues.find((v) => v.name === "Pictures").id;
      setPhotoLoader(false);
      const processedData = res.map((result) => ({
        ...result,
        type: PhotoType,
        isDamaged: false,
        isToBeDeleted: null,


      }));

      processedData &&
        processedData[0] &&
        processedData.forEach((item) => {
          setNewImagesArray((prevState) => {
            return [
              ...prevState,
              {
                url: item.url,
                uniqueFileId: item.uniqueFileId,
                fileName: item.fileName,
                isDamaged: item.isDamaged,
                typeId: item.type,
                isToBeDeleted: item.isToBeDeleted,
                itemId: Item?.id || _.uniqueId(),
                // shipmentId: item?.shipmentId || 0,

              },
            ];
          });
        });
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");

      setPhotoLoader(false);
    }
  };
  const onsubmitHandler = () => {
    setItem({
      ...Item,
      shipmentItemEvidences: newImagesArray
    })
    toggle(false)
  }

  // let imagesCount = _.filter(
  //   newImagesArray || [],
  //   (d) => d.typeId == PhotoType
  // ).length;
  let imagesCount = newImagesArray?.length
  return (
    <div style={{
      display: "flex", padding: 20, flexDirection: "column", height: "100%",

    }} >
      <div className="row " style={{ marginLeft: -25, height: "100%", }}>
        {
          // --------cross button
        }
        <div style={{ height: "80%", overflow: "scroll" }}>
          <div>
            <span style={{ display: "flex", justifyContent: "flex-end", }}>
              <CancelOutlinedIcon color='red'
                style={{ cursor: "pointer" }}
                onClick={() => { toggle(false) }} />
            </span>
            <div className="col-md-2" style={{ display: "flex",marginBottom:10,marginLeft:10 }} >
              <InputLabel className="goodsin-form-section-header-name" >
                {" "}
                {!detailsView ? imagesCount : selectedItemImagesArray?.length} PHOTOS
              </InputLabel>
            </div>
            <div className="col-md-10">
              {photoLoader && (
                <div
                  className="spinner-border spinner-border-sm text-primary"
                  role="status"
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </div>
          </div>
          {
            // ----------- image shows
          }
          <div className="row" style={{ height: "80 %",marginLeft:5 }}>
            {detailsView ?

              //selected item images array from details view
              selectedItemImagesArray.filter(
                (item) =>
                  item.typeId ==
                  lookupValues?.find((v) => v.name === "Pictures").id &&
                  !item.isToBeDeleted)
                .map((d, index) => {
                  return (
                    <div
                      key={index}
                      className="mb-2 pt-2 images-shown-style image-grid"
                      style={{ marginBottom: 2, width: 160, paddingTop: 10 }}
                    >
                      <Box
                        className="image-box-style"
                        component="img"
                        style={{ height: 120, width: "100%" }}
                        alt="The house from the offer."
                        src={d?.url}
                        onClick={() => openFullScreen(d.url)}
                      />
                      {d?.isDamaged ? (
                        <div className="dmg-icon-shown-on-image-style">
                          <img
                            height={25}
                            width={25}
                            src={IconError}
                            alt="dmg"
                          />
                        </div>
                      ) : null}
                    </div>)
                })

              // images while adding and editing goodsin
              : newImagesArray
                .filter(
                  (item) =>
                    item.typeId ==
                    lookupValues.find((v) => v.name === "Pictures").id &&
                    !item.isToBeDeleted
                )
                .map((d, index) => {
                  return (
                    <div
                      key={index}
                      style={{ marginBottom: 2, width: 130, paddingTop: 10 }}
                    >
                      <Box
                        component="img"
                        style={{ height: 88, width: "100%" }}
                        alt="The house from the offer."
                        src={d?.url}
                      />
                      {
                        !isdisable &&
                        <div
                          style={{
                            display: "flex",
                            justifyItems: "center",
                            height: 20,
                            marginTop: 6,
                          }}
                          className="checkbox-style-class"
                        >
                          <Checkbox
                            style={{ color: "#E94F37" }}
                            checked={d.isDamaged}
                            onChange={({ target }) =>
                              IsDamageChangeHandler(target.checked, d.uniqueFileId)
                            }
                          />
                          <InputLabel
                            className="checkbox-label"
                            style={{
                              fontSize: 10,
                              fontFamily: "Montserrat-Regular",
                            }}
                          >
                            {" "}
                            DAMAGES
                          </InputLabel>

                        </div>
                      }
                      {!isdisable &&
                        <div
                          onClick={() => {
                            let OldData = _.cloneDeep(newImagesArray);
                            _.remove(
                              OldData,
                              (i) => i.uniqueFileId === d.uniqueFileId
                            );
                            setNewImagesArray([...OldData]);
                          }}
                          style={{
                            display: "flex",
                            justifyItems: "center",
                            alignItems: "center",
                            paddingLeft: 4,
                            height: 20,
                            cursor: "pointer",
                          }}
                        >
                          <RemoveCircleOutlineOutlinedIcon
                            fontSize="20"
                            color="red"
                          />
                          <InputLabel
                            style={{
                              fontSize: 10,
                              marginBottom: 10,
                              color: "red",
                              fontFamily: "Montserrat-Regular",
                            }}
                          >
                            {" "}
                            REMOVE
                          </InputLabel>
                        </div>}
                    </div>
                  );
                })}

            {isFullScreen && (
              <div className="full-screen-overlay" onClick={closeFullScreen}>
                <div className="full-screen-image">
                  <img src={selectedImage} alt="Full-screen Image" />
                </div>
              </div>
            )}

            {!isdisable && !detailsView &&
              <div style={{ marginBottom: 2, width: 130, paddingTop: 10 }}>
                <div className="row mt-2">
                  <div className="fileUpload">
                    <input
                      type="file"
                      className="upload"
                      accept="image/png, image/jpeg, image/jpg"
                      multiple
                      onChange={(e) => photoUpload(e)}
                    />
                    <div
                      style={{
                        border: "1px solid #4879e2",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <i
                        className="bi bi-plus-circle-fill"
                        style={{ color: "#4879e2" }}
                      ></i>
                      <div
                        style={{
                          fontSize: 10,
                          color: "#0045d9",
                          fontFamily: "Montserrat-Regular",
                        }}
                      >
                        {" "}
                        ADD PHOTO
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }

          </div>
        </div>

        {!detailsView &&
          <div style={{ height: "20%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
            <div >
              <Button onClick={() => onsubmitHandler()}
                variant="outlined"
                style={{ marginRight: 10 }}
              >submit</Button>
              <Button onClick={() => toggle(false)}
                variant="outlined"
                color='error'
              > cancel</Button>
            </div>
          </div>
        }
      </div>
    </div >
  )
}

export default UploadImage;